import React from 'react';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  const forWho = ['Mujeres de 65+ que desean tener su hogar y sus asuntos en orden.', 'Madres y abuelas que son las guardianas de las fotos y la historia familiar.', 'Personas que tienen cuentas de banco o inversiones que se manejan por internet.', 'Mujeres que quieren evitarle trámites legales innecesarios a sus hijos en el futuro.'];
  const notForWho = ['Expertas en ciberseguridad que buscan códigos de encriptación avanzados.', 'Personas que no tienen ninguna cuenta de banco o correo electrónico.', 'Quienes prefieren dejar que el azar decida qué pasará con sus activos.'];
  return <section className="py-16 md:py-24 px-4 bg-white border-t border-cream-dark" data-id="element-1">
      <div className="max-w-6xl mx-auto" data-id="element-2">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-3">
          {/* Para quién es */}
          <div className="bg-cream-dark/30 p-8 md:p-10 rounded-sm border-t-4 border-burgundy" data-id="element-4">
            <h3 className="text-3xl font-bold text-burgundy mb-8 text-center" data-id="element-5">
              Este sistema ES para usted si:
            </h3>
            <ul className="space-y-6" data-id="element-6">
              {forWho.map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-7">
                  <div className="bg-burgundy/10 p-1 rounded-full shrink-0 mt-1" data-id="element-8">
                    <Check className="w-6 h-6 text-burgundy" data-id="element-9" />
                  </div>
                  <span className="text-lg" data-id="element-10">{text}</span>
                </li>)}
            </ul>
          </div>

          {/* Para quién NO es */}
          <div className="bg-gray-50 p-8 md:p-10 rounded-sm border-t-4 border-gray-300" data-id="element-11">
            <h3 className="text-3xl font-bold text-gray-600 mb-8 text-center" data-id="element-12">
              Este sistema NO es para:
            </h3>
            <ul className="space-y-6" data-id="element-13">
              {notForWho.map((text, i) => <li key={i} className="flex items-start gap-4 text-gray-600" data-id="element-14">
                  <div className="bg-gray-200 p-1 rounded-full shrink-0 mt-1" data-id="element-15">
                    <X className="w-6 h-6 text-gray-500" data-id="element-16" />
                  </div>
                  <span className="text-lg" data-id="element-17">{text}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}